// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ba0D_","buttons":"styles_buttons__3OOkO"};